var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadingButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.905,
    height: 93.905,
    viewBox: "0 0 93.905 93.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.349 -0.443) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.443 0.443)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.905,
    height: 93.905,
    transform: "translate(93.905) rotate(90)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.179,28.675H16.388l14.321-17.2a3.95,3.95,0,1,0-6.076-5.05L4.907,30.1a4.7,4.7,0,0,0-.355.592.5.5,0,0,1-.276.513,3.79,3.79,0,0,0,0,2.841.5.5,0,0,0,.276.513,4.7,4.7,0,0,0,.355.592L24.634,58.817a3.95,3.95,0,1,0,6.076-5.05l-14.321-17.2H63.179a3.945,3.945,0,0,0,0-7.89Z",
    transform: "translate(11.185 14.127)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingButton);
export default __webpack_public_path__ + "static/media/uploadingButton.1c0a2fd76432fc0031cb7741927afa96.svg";
export { ForwardRef as ReactComponent };